import * as React from 'react';
import { renderEmpty } from '../../common/Render';

import { IReportSettings } from '../../../../interfaces';

import ISettings from './ISettings';
import { IWidgetProps } from '../../StateWidgetContainer';

import SummaryTable from './SummaryTable';

interface IProps extends IWidgetProps {
    settings: ISettings;
}

export default class Widget extends React.Component<IProps, void> {
    static propTypes = {
        nodes: React.PropTypes.array.isRequired,
        states: React.PropTypes.object.isRequired,
        settings: React.PropTypes.object.isRequired,
        reportSettings: React.PropTypes.object.isRequired,
    };

    renderData(nodes, states, startDate: Date, endDate: Date, settings: ISettings) {
        const byParent = nodes.reduce((map, node) => {
            const parentId = node._searchIdx.parentNames.slice(2).join(' / ');

            if (!map[parentId]) {
                map[parentId] = [];
            }

            map[parentId].push(node);

            return map;
        }, {});

        const parents = Object.keys(byParent).sort();

        return parents.map(function (parent) {
            const parentKey = `parent-${parent}`;

            return (
                <div key={parentKey} className="space-xl">
                    <h4>{parent}</h4>
                    <SummaryTable nodes={byParent[parent]} states={states} startDate={startDate} endDate={endDate} settings={settings} />
                </div>
            );
        });
    }

    render() {
        const { nodes, states, settings, reportSettings } = this.props;

        const startDate = new Date(reportSettings.startMs);
        const endDate = new Date(reportSettings.endMs);

        let renderedData;
        if (nodes && nodes.length) {
            renderedData = this.renderData(nodes, states, startDate, endDate, settings);
        } else {
            renderedData = renderEmpty();
        }

        return (
            <div>
                {renderedData}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widget/alerts/listAlertSummary/Widget.tsx